// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  border-radius: 15px;
  border: none;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.modal-header {
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 15px 15px 0 0;
}

.modal-title {
  color: #495057;
  font-weight: 600;
}

.modal-title i {
  margin-right: 0.5rem;
}

.form-control {
  border-radius: 10px;
  border: 2px solid #e9ecef;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-align: center;
}

.form-control:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}

.form-control.is-invalid {
  border-color: #dc3545;
}

.btn-primary {
  border-radius: 10px;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
  border: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #0b5ed7 0%, #0a58ca 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);
}

.btn-outline-secondary {
  border-radius: 10px;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
}

.btn-outline-secondary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.text-muted {
  font-size: 0.95rem;
  line-height: 1.5;
}

/* Animación de entrada */
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

.modal.show .modal-dialog {
  transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/shared/verify-2fa-modal/verify-2fa-modal.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".modal-content {\n  border-radius: 15px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\n}\n\n.modal-header {\n  border-bottom: 1px solid #e9ecef;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 15px 15px 0 0;\n}\n\n.modal-title {\n  color: #495057;\n  font-weight: 600;\n}\n\n.modal-title i {\n  margin-right: 0.5rem;\n}\n\n.form-control {\n  border-radius: 10px;\n  border: 2px solid #e9ecef;\n  font-size: 1.2rem;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  text-align: center;\n}\n\n.form-control:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n}\n\n.form-control.is-invalid {\n  border-color: #dc3545;\n}\n\n.btn-primary {\n  border-radius: 10px;\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n  background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);\n  border: none;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #0b5ed7 0%, #0a58ca 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);\n}\n\n.btn-outline-secondary {\n  border-radius: 10px;\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n}\n\n.btn-outline-secondary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n.text-muted {\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n/* Animación de entrada */\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n\n.modal.show .modal-dialog {\n  transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
